<template>
  <div class="upload-file" @paste="handlePaste">
    <!-- 粘贴区域输入框 -->
<!--    <div class="paste-area" v-if="showPasteTip">
      <el-input
        v-model="pasteContent"
        placeholder="在此处按 Ctrl+V 粘贴图片"
        @paste.native="handlePaste"
        size="small"
        clearable
      />
      <span class="paste-tip-text">支持粘贴截图或剪贴板中的图片</span>
    </div>-->

    <!-- 上传组件  可通过复制粘贴进行上传 -->
    <el-upload
      multiple
      drag
      :action="uploadFileUrl"
      :before-upload="handleBeforeUpload"
      :file-list="fileList"
      :limit="limit"
      :on-error="handleUploadError"
      :on-exceed="handleExceed"
      :on-success="handleUploadSuccess"
      :show-file-list="false"
      :headers="headers"
      class="upload-file-uploader"
      ref="upload"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <!-- 添加一个小提示 -->
      <span style="color: #909399; font-size: 12px; margin-left: 8px;">
          Ctrl+V 粘贴
        </span>
    </el-upload>

    <!-- 文件列表 -->
    <fileList :fileList="fileList" :isDelete="true" @input="handleInput" />
  </div>
</template>

<script>
import { Loading } from 'element-ui';
export default {
  name: "FileDragUpload",
  props: {
    // 值
    value: [String, Object, Array],
    // 数量限制
    limit: {
      type: Number,
      default: 10,
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 20,
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => [
        // 图片
        "bmp", "gif", "jpg", "jpeg", "png",
        // word excel powerpoint
        "doc", "docx", "xls", "xlsx", "ppt", "pptx", "html", "htm", "txt",
        // 压缩文件
        "rar", "zip", "gz", "bz2",
        // 视频格式
        "mp4", "avi", "rmvb",
        // pdf
        "pdf"
      ],
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true
    },
    // 是否显示粘贴区域
    showPasteTip: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      number: 0,
      uploadList: [],
      baseUrl: this.$base_url,
      uploadFileUrl: this.$base_url + "/api/utils/uploadFile", // 上传的图片服务器地址
      headers: {
        'token': sessionStorage.getItem('token')
      },
      fileList: [],
      pasteContent: '', // 粘贴输入框内容
      loadingInstance: null // loading实例
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          let temp = 1;
          // 首先将值转为数组
          const list = Array.isArray(val) ? val : this.value.split(',');
          // 然后将数组转为对象数组
          this.fileList = list.map(item => {
            if (typeof item === "string") {
              item = { fileName: item, url: item };
            }
            item.uid = item.uid || new Date().getTime() + temp++;
            return item;
          });
        } else {
          this.fileList = [];
          return [];
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    // 是否显示提示
    showTip() {
      // return this.isShowTip && (this.fileType || this.fileSize);
    },
  },
  methods: {
    // 处理粘贴事件
    handlePaste(event) {
      // 获取剪贴板数据
      const clipboardData = event.clipboardData || window.clipboardData
      if (!clipboardData) return

      // 获取剪贴板中的项目
      const items = clipboardData.items
      if (!items) return

      // 遍历剪贴板项目
      for (let i = 0; i < items.length; i++) {
        const item = items[i]

        // 检查是否为图片类型
        if (item.kind === 'file') {
          // 阻止默认粘贴行为
          event.preventDefault()

          // 获取图片文件
          const file = item.getAsFile()
          if (file) {
            // 复用已有的校验逻辑
            this.handlePastedFile(file)
          }
          break // 只处理第一张图片
        }
      }

      // 清空输入框
      this.$nextTick(() => {
        this.pasteContent = ''
      })
    },

    // 处理粘贴的文件（复用校验逻辑）
    handlePastedFile(file) {
      // 检查文件数量限制
      if (this.fileList.length >= this.limit) {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`);
        return false;
      }

      // 关键：如果没有文件类型信息，提示用户
      if (!file.type && !file.name) {
        this.$message.warning('无法识别剪贴板中的内容，请直接复制文件而不是内容');
        return false;
      }

      // 处理文件名
      if (!file.name) {
        // 尝试从MIME类型获取扩展名
        let extension = this.getExtensionFromMime(file.type);

        if (!extension) {
          // 如果真的无法识别，给出友好提示
          this.$message.warning(`无法识别的文件类型，请直接复制文件而不是内容`);
          return false;
        }

        const timestamp = new Date().getTime();
        Object.defineProperty(file, 'name', {
          value: `pasted-${timestamp}.${extension}`,
          writable: true
        });
      }
      // 复用 handleBeforeUpload 的校验逻辑
      const isValid = this.validateFile(file);

      if (isValid) {
        // 直接上传文件
        this.uploadPastedFile(file);
      }
    },
    // 根据MIME类型获取扩展名
    getExtensionFromMime(mimeType) {
      const mimeMap = {
        // 文档类
        'application/pdf': 'pdf',
        'application/msword': 'doc',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
        'application/vnd.ms-excel': 'xls',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
        'application/vnd.ms-powerpoint': 'ppt',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
        'text/plain': 'txt',
        'text/html': 'html',

        // 图片类
        'image/jpeg': 'jpg',
        'image/png': 'png',
        'image/gif': 'gif',
        'image/webp': 'webp',
        'image/svg+xml': 'svg',
        'image/bmp': 'bmp',
        'image/tiff': 'tiff',

        // 压缩文件
        'application/zip': 'zip',
        'application/x-zip-compressed': 'zip',
        'application/x-rar-compressed': 'rar',
        'application/x-7z-compressed': '7z',
        'application/gzip': 'gz',
        'application/x-bzip2': 'bz2',

        // 视频类
        'video/mp4': 'mp4',
        'video/x-msvideo': 'avi',
        'video/quicktime': 'mov',
        'video/x-ms-wmv': 'wmv',
        'video/webm': 'webm',

        // 音频类
        'audio/mpeg': 'mp3',
        'audio/wav': 'wav',
        'audio/ogg': 'ogg',

        // 其他常见格式
        'application/json': 'json',
        'application/xml': 'xml',
        'application/rtf': 'rtf'
      };

      return mimeMap[mimeType] || null;
    },
    // 文件校验（从 handleBeforeUpload 提取的校验逻辑）
    validateFile(file) {
      // 校检文件大小
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }

      return true;
    },

    // 上传粘贴的文件
    uploadPastedFile(file) {
      // 显示loading
      this.loadingInstance = Loading.service({
        text: "正在上传文件，请稍候...",
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      // 增加计数，与原有上传逻辑保持一致
      this.number++;

      // 创建FormData
      const formData = new FormData();
      formData.append('file', file);

      // 发送上传请求
      this.$http({
        method: 'post',
        url: this.uploadFileUrl,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
          'token': sessionStorage.getItem('token')
        }
      }).then(res => {
        if (res.data && res.data.data) {
          // 复用上传成功的处理逻辑
          this.handlePasteUploadSuccess(res, file);
        } else {
          this.handlePasteUploadError(new Error('返回数据格式错误'), file);
        }
      }).catch(err => {
        this.handlePasteUploadError(err, file);
      });
    },

    // 粘贴上传成功处理（复用原有成功逻辑的风格）
    handlePasteUploadSuccess(res, file) {
      // 构造与原有上传成功一致的数据格式
      const successRes = {
        fileName: res.data.fileName || file.name,
        data: res.data.data
      };

      // 添加到上传列表
      this.uploadList.push({ fileName: successRes.fileName, fileUrl: successRes.data });

      // 检查是否所有文件都上传完成
      if (this.uploadList.length === this.number) {
        this.fileList = this.fileList.concat(this.uploadList);
        this.uploadList = [];
        this.number = 0;
        this.$emit("input", this.fileList);

        // 关闭loading
        if (this.loadingInstance) {
          this.loadingInstance.close();
          this.loadingInstance = null;
        }

        this.$message.success('文件上传成功');
      }
    },

    // 粘贴上传失败处理
    handlePasteUploadError(err, file) {
      console.error('粘贴上传失败', err);
      this.$message.error("上传文件失败，请重试");

      // 减少计数
      this.number--;

      // 关闭loading
      if (this.loadingInstance) {
        this.loadingInstance.close();
        this.loadingInstance = null;
      }
    },

    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      // 复用校验逻辑
      const isValid = this.validateFile(file);

      if (isValid) {
        this.loadingInstance = Loading.service({
          text: "正在上传文件，请稍候...",
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.number++;
      }

      return isValid;
    },

    // 文件个数超出
    handleExceed() {
      this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`);
    },

    // 上传失败
    handleUploadError(err) {
      this.$message.error("上传文件失败，请重试");
      this.number--;
      if (this.loadingInstance) {
        this.loadingInstance.close();
        this.loadingInstance = null;
      }
    },

    // 上传成功回调
    handleUploadSuccess(res) {
      this.uploadList.push({ fileName: res.fileName, fileUrl: res.data });
      if (this.uploadList.length === this.number) {
        this.fileList = this.fileList.concat(this.uploadList);
        this.uploadList = [];
        this.number = 0;
        this.$emit("input", this.fileList);

        if (this.loadingInstance) {
          this.loadingInstance.close();
          this.loadingInstance = null;
        }
      }
    },

    handleInput(fileList) {
      this.$emit("input", fileList);
    },

    // 获取文件名称
    getFileName(name) {
      // 实现获取文件名的逻辑
      return name || '';
    },

    // 对象转成指定字符串分隔
    listToString(list, separator) {
      let strs = "";
      separator = separator || ",";
      for (let i in list) {
        strs += list[i].url + separator;
      }
      return strs != '' ? strs.substr(0, strs.length - 1) : '';
    }
  }
};
</script>

<style scoped>
.paste-area {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 4px;
  border: 1px dashed #dcdfe6;
  display: flex;
  align-items: center;
}

.paste-area .el-input {
  width: 250px;
  margin-right: 10px;
}

.paste-tip-text {
  color: #909399;
  font-size: 12px;
}
</style>
